import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/colors";

export const Heading = withViewportStyle("h2")`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  font-weight: ${({ theme }) =>
    theme.typography.patterns.headingFour.fontWeight};
  font-size: ${rem(20)};
  line-height: ${rem(32)};
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  margin-bottom: ${rem(8)};

  ${(props) => props.$viewport.mobile`
    font-size: ${rem(18)};
    line-height: ${rem(26)};
  `}
`;

export const Body = withViewportStyle("p")`
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  font-weight: ${({ theme }) => theme.typography.patterns.paragraph.fontWeight};
  font-size: ${rem(14)};
  line-height: ${rem(26)};
  color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};

  ${(props) => props.$viewport.mobile`
    font-size: ${rem(12)};
    line-height: ${rem(20)};
  `}
`;
